import React from 'react'
import styled from 'styled-components'

const StyledSpan = styled.span`
  color: #b7becb;
`

const EmptyString = () => {
  return <StyledSpan>－</StyledSpan>
}

export default EmptyString
